/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const EVENT_NAMES = {
  createTrip: 'create_trip',
  dateSelection: 'date_selection',
  stationSelection: 'station_selection',
  search: 'search',
  searchWidgetViewed: 'aa_flt_searchwidget_viewed',
  click: 'click',
};

export const CATEGORY = {
  projectLink: 'Project Link',
  flightBaseCurrency: 'Flight|Base Currency',
  flightMultiCurrency: 'Flight|Multi Currency',
  searcgWidgetNotFoung: 'hpsearchwidget|not found',
  flightSearchWidget: 'Flights|flightsearchwidget',
  homepageDatepicker: 'hpsearchwidget|datepicker',
};

export const ANALYTICS_CONSTANTS = {
  FLIGHTS: 'Flights',
  FLIGHT: 'Flight',
  HOME: 'Home',
  AA: 'aa',
  OTA: 'ota',
  CITY: 'city',
  AIRPORT: 'airport',
  FLIGHT_SEARCH_WIDGET: 'flightsearchwidget',
  ORIGIN: 'origin',
  DEST: 'dest',
  HP_SEARCH_WIDGET: 'hpsearchwidget',
  DATE_PICKER: 'datepicker',
  FLIGHTS_OTA: 'Flights OTA',
  DATE_FORMAT: 'yyyy-MM-dd',
  RT: 'RT',
  OW: 'OW',
  DOMESTIC: 'Domestic',
  INTERNATIONAL: 'International',
};

export const SCREEN_NAME = {
  flightSearchWidget: 'Flight Search Widget V2',
  home: 'Home V2',
};

export const EVENTS = {
  trackEventNoEcommerce: 'trackEventNoEcommerce',
  productImpressionSearch: 'aa_flt_search',
};

export const YN = { Y: 'Y', N: 'N' } as const;

export interface SearchParams {
  departdate: string;
  returndate: string;
  currency: string;
  originairport: string;
  destinationairport: string;
  origincountry: string;
  destinationcountry: string;
  journeytype: string;
  flighttype: string;
  lengthofstay: number;
  totalpax: number;
  adult: number;
  kid: number;
  infant: number;
  voucher: string;
}

export interface FlightSearchParams {
  label: string;
  category: string;
}
export interface FlightSearchParamsWithSearch extends FlightSearchParams {
  searchParams: SearchParams;
}

export interface FlightSearchClickParams {
  originairport: string;
  destinationairport: string;
  origincountry: string;
  destinationcountry: string;
  departdate: string;
  returndate: string;
  journeytype: string;
  lengthofstay: number;
  routetype: string | null;
  flightcode: string | null;
  flighttype: string;
  adult: number;
  kid: number;
  infant: number;
  totalpax: number;
  coupon: string;
  fareclass: string;
  bigpoints: 'Y' | 'N';
  snapbundle: 'Y' | 'N';
}

export interface AnalyticsBuilderResult {
  nativeParams: Record<string, any>;
  webParams: Record<string, any>;
}
